import http from '@/utils/http';

export default {
	// 采购单列表 (V2)
	list: data => {
		return http({ url: '/api/admin/v2/purchase/list', data }).then(r => r);
	},
	// 入库操作 (V2)
	inStock: data => {
		return http({ url: '/api/admin/v2/purchase/inStock', data, tip: true }).then(r => r);
	},
	// 更新采购单 (V2)
	update: data => {
		return http({ url: '/api/admin/v2/purchase/update', data, tip: true }).then(r => r);
	},
	// 生成分拣单（带同步订单）(V2)
	generateSortingWithSync: data => {
		return http({ url: '/api/admin/v2/sorting/generateSortingWithSync', data, tip: true }).then(r => r);
	},
	// 获取分拣单生成进度 (V2)
	getGenerateProgress: data => {
		return http({ url: '/api/admin/v2/sorting/getGenerateProgress', data }).then(r => r);
	},
};